import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { Crosshair } from "lucide-react";

export default function MasterTargets() {
  return (
    <MasterDataPage
      title="Calibration Targets"
      subtitle="Static target library — OEM measurements, distances, scan tool compatibility"
      entity="targets"
      testId="targets"
      icon={Crosshair}
      defaultForm={{ name: "", oem: "", system_type: "front_camera", target_type: "static", distance_mm: 1500, height_mm: 1200, lateral_offset_mm: 0, estimated_time_min: 60 }}
      fields={[
        { key: "name", label: "Target Name", required: true, span: 2 },
        { key: "oem", label: "OEM", required: true, type: "select", options: ["Toyota", "Honda", "Ford", "GM", "BMW", "Mercedes-Benz", "Audi", "VW", "Subaru", "Nissan", "Hyundai", "Kia", "Stellantis", "Tesla", "Volvo", "Lexus", "Acura", "Mazda"] },
        { key: "system_type", label: "System", required: true, type: "select", options: [{value:"front_camera",label:"Front Camera"},{value:"front_radar",label:"Front Radar"},{value:"rear_radar",label:"Rear Radar"},{value:"surround_view",label:"Surround View 360°"},{value:"blind_spot",label:"Blind Spot"},{value:"park_assist",label:"Park Assist"}] },
        { key: "target_type", label: "Calibration Type", type: "select", options: ["static", "dynamic", "both"] },
        { key: "distance_mm", label: "Distance (mm)", type: "number" },
        { key: "height_mm", label: "Height (mm)", type: "number" },
        { key: "lateral_offset_mm", label: "Lateral Offset (mm)", type: "number" },
        { key: "tilt_degrees", label: "Tilt (°)", type: "number" },
        { key: "estimated_time_min", label: "Est. Time (min)", type: "number" },
        { key: "target_part_number", label: "Target Part #" },
        { key: "procedure_notes", label: "Procedure Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "oem", label: "OEM" },
        { key: "name", label: "Target" },
        { key: "system_type", label: "System" },
        { key: "target_type", label: "Type" },
        { key: "distance_mm", label: "Distance", render: (r) => r.distance_mm ? `${r.distance_mm}mm` : "—" },
        { key: "estimated_time_min", label: "Time", render: (r) => `${r.estimated_time_min || 60}min` },
      ]}
    />
  );
}
